<div class="relative inline-block text-left select-none">
  <!-- Trigger Button -->
  <button
    type="button"
    [disabled]="disabled"
    (click)="toggleDropdown($event)"
    class="inline-flex items-center justify-between rounded-sm border border-solid font-medium select-none transition-colors duration-150 shrink-0 cursor-pointer"
    [ngClass]="[sizeClasses, variantClasses, className]"
  >
    <!-- Left Icon Slot / Input -->
    <ng-content select="[left-icon]"></ng-content>
    @if (leftIcon) {
      <span class="inline-flex items-center shrink-0" [innerHTML]="leftIcon"></span>
    }

    <!-- Label or Main Content -->
    @if (label) {
      <span class="truncate">{{ label }}</span>
      @if (badge !== null && badge !== undefined && badge !== '' && badge !== 0) {
        <span class="inline-flex items-center justify-center min-w-[18px] h-4 px-1 text-[10px] font-bold rounded-full bg-button-primary-default text-text-inverted-primary leading-none shrink-0">
          {{ badge }}
        </span>
      }
    } @else {
      <ng-content select="[trigger]"></ng-content>
      @if (options.length === 0) {
        <ng-content></ng-content>
      }
    }

    <!-- Right Caret Icon -->
    @if (showCaret) {
      <svg
        class="w-4 h-4 ml-1 shrink-0 transition-transform duration-200 text-text-half-dimmed"
        [class.rotate-180]="isOpen"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    }
  </button>

  <!-- Dropdown Menu -->
  @if (isOpen) {
    <div
      class="absolute mt-1.5 z-50 min-w-[180px] rounded-lg bg-combobox-panel-bg border border-combobox-panel-border p-1.5 shadow-xl shadow-black/50 focus:outline-none"
      [ngClass]="[align === 'right' ? 'right-0' : 'left-0', menuClassName]"
      (click)="$event.stopPropagation()"
    >
      @if (options.length > 0) {
        <div class="flex flex-col gap-0.5" role="menu">
          @for (option of options; track option.id || option.value || option.label) {
            @if (option.divider) {
              <div class="h-px bg-combobox-list-item-border my-1"></div>
            } @else {
              <button
                type="button"
                role="menuitem"
                [disabled]="option.disabled"
                (click)="onSelect(option, $event)"
                class="w-full flex items-start gap-2.5 px-3 py-2 text-xs md:text-sm rounded-md transition-colors cursor-pointer text-left select-none"
                [ngClass]="{
                  'text-text-destructive hover:bg-button-destructive-default/10 hover:text-text-destructive': option.destructive && !option.disabled,
                  'text-text-primary hover:bg-combobox-list-item-hover-bg active:bg-combobox-list-item-hover-bg': !option.destructive && !option.disabled && !isOptionSelected(option),
                  'bg-combobox-list-item-hover-bg text-text-primary font-medium': !option.destructive && !option.disabled && !multiSelect && isOptionSelected(option),
                  'text-text-primary hover:bg-combobox-list-item-hover-bg': !option.destructive && !option.disabled && multiSelect && isOptionSelected(option),
                  'text-text-dimmed cursor-not-allowed opacity-60': option.disabled
                }"
              >
                @if (multiSelect) {
                  <app-checkbox
                    [checked]="isOptionSelected(option)"
                    class="mt-0.5 shrink-0 pointer-events-none"
                  />
                }

                <div class="flex flex-col min-w-0 flex-1 pr-2">
                  <div class="flex items-center gap-2">
                    @if (option.icon) {
                      <span class="shrink-0 inline-flex items-center" [innerHTML]="option.icon"></span>
                    }
                    <span class="truncate font-medium text-text-primary">{{ option.label }}</span>
                  </div>
                  @if (option.description) {
                    <span class="text-xs text-text-half-dimmed mt-0.5 leading-tight font-normal whitespace-normal">{{ option.description }}</span>
                  }
                </div>

                @if (!multiSelect && isOptionSelected(option) && !option.destructive) {
                  <svg class="w-4 h-4 ml-2 shrink-0 text-text-primary" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                  </svg>
                }
              </button>
            }
          }

          @if (multiSelect && effectiveSelectedCount > 0) {
            <div class="pt-1.5 mt-1 border-t border-combobox-list-item-border/60 flex items-center justify-between px-2 pb-0.5">
              <span class="text-[11px] text-text-half-dimmed font-medium">
                {{ effectiveSelectedCount }} selected
              </span>
              <button
                type="button"
                (click)="clearSelection($event)"
                class="text-[11px] text-text-dimmed hover:text-text-primary font-semibold transition-colors cursor-pointer"
              >
                Clear
              </button>
            </div>
          }
        </div>
      } @else {
        <ng-content select="[menu]"></ng-content>
      }
    </div>
  }
</div>
